import React from 'react';
import { connect } from 'react-redux';
import { setToggleAuthSetting } from '../../actions/css';
import { setSearchModalState } from '../../actions/css';
import { getUserDetails } from '../../helpers/auth';
import { setUser } from '../../actions/auth';
import {setOSCChannelState} from '../../actions/notifications';
// import paths from '../../helpers/paths';
// import { history } from '../../routers/AppRouter';
import { setProductCart, setCartTotalQuantity, } from '../../actions/cart';
import { getCartDetails, setCartDetails } from '../../helpers/cart';
import searchIcon from '../../images/icons/iconsearch.png';
import userIcon from '../../images/icons/user.png';

class SearchBarSS extends React.Component{
  componentDidMount (){
    const { dispatch } = this.props; 
    try{
      let retrieveCartDetails = JSON.parse(getCartDetails());
      if(retrieveCartDetails == null || retrieveCartDetails == 'null' ||
         retrieveCartDetails === undefined || retrieveCartDetails === 'undefined' ){
           setCartDetails(JSON.stringify([]));
         }else{
          let retrieveCartProduct = getCartDetails();
          let parseRetrievedCart;
          let reduceParsedCart
          parseRetrievedCart = JSON.parse(retrieveCartProduct);
          reduceParsedCart = parseRetrievedCart.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
          dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
          dispatch(setProductCart(retrieveCartDetails));
          setCartDetails(JSON.stringify(retrieveCartDetails));
         }
    }catch(err){
      dispatch(setProductCart([]));
      setCartDetails(JSON.stringify([]));
    };

    try{
      let retrieveUserDetails = JSON.parse(getUserDetails());
      dispatch(setUser(retrieveUserDetails));
    }catch(err){
      dispatch(setUser({}));
    };
  };

  componentWillMount(){
    window.scrollTo({top: 0, left: 0, behaviour: 'smooth'});
  };

  render(){
    const { dispatch } = this.props; 
    const { toggleAuthSettings } = this.props.css;
    return(
      <div className='search-small-screen'>
        <table className='search-table-ss' align='right'>
          <tbody>
            <tr>
              <td onClick={() => {
                dispatch(setSearchModalState(true));
              }} className='search-image-td'>
                <img className='useIco' src={searchIcon} alt='lifecarefront.com | Life Care Properties | Listings' 
                  title='lifecarefront.com | Life Care Properties | Listings' />
                {/* <i className="search-icon-image-ss fa fa-search"></i> */}
              </td>
              {false && (
                <td onClick={() => {
                  dispatch(setOSCChannelState(true));
                  // dispatch(setToggleAuthSetting(!toggleAuthSettings));
                }} className='search-image-td'>
                  <img className='useIco' src={userIcon} alt='lifecarefront.com | Life Care Properties | Listings' 
                    title='lifecarefront.com | Life Care Properties | Listings' />
                  {/* <i className="search-icon-image-ss fa fa-user-o"></i> */}
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(SearchBarSS); 

